import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, NgIf],
  template: `
    <section class="login-page">
      <div class="login-shell">
        <aside class="login-hero">
          <div class="brand-block login-brand">
            <img class="brand-logo-mark brand-logo-mark-lg" src="assets/logo-mark.png" alt="" aria-hidden="true">
            <div class="brand-copy">
              <h1>Romaneio Fácil</h1>
              <p>Produção e contagem</p>
            </div>
          </div>

          <div class="login-hero-panel login-logo-panel" aria-hidden="true">
            <img class="login-logo-full" src="assets/logo.png" alt="">
          </div>
        </aside>

        <form class="login-card" [formGroup]="form" (ngSubmit)="entrar()">
          <div class="login-card-header">
            <span>Acesso restrito</span>
            <h2>Entrar no sistema</h2>
          </div>

          <label>
            Email ou CPF
            <input formControlName="identificador" autocomplete="username" autofocus>
          </label>

          <label>
            Senha
            <input type="password" formControlName="senha" autocomplete="current-password">
          </label>

          <p class="error" *ngIf="erro">{{ erro }}</p>
          <button class="login-submit" type="submit" [disabled]="form.invalid">Entrar</button>
        </form>
      </div>
    </section>
  `
})
export class LoginComponent {
  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  private router = inject(Router);
  erro = '';

  form = this.fb.nonNullable.group({
    identificador: ['', Validators.required],
    senha: ['', Validators.required]
  });

  entrar() {
    this.erro = '';
    this.auth.login(this.form.value.identificador || '', this.form.value.senha || '').subscribe({
      next: () => this.router.navigateByUrl(this.auth.firstAllowedPath()),
      error: (error) => (this.erro = error.error?.message || 'Não foi possível entrar')
    });
  }
}
